/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

/* eslint-disable max-len */
/* flow-disable */

import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import GrayPanel from '../../components/GrayPanel';
import RodoContent from '../../components/RodoContent';
import { connect } from 'react-redux';
import { runService } from '../../actions/eservices';
import PowrotDoListyEuslug from '../../components/PowrotDoListyEuslug';
import { isMobileView, isTabletView, renderHelpDesc, scrollToSection } from '../../components/utils/utils';
import AttachmentsPanel from '../../components/AttachmentsPanel';
import EmptyFileDownloader from '../../components/EmptyFileDownloader';
import { PanelStyle } from '../../constants';
import { DecisionContainer, PersonalDataContainer } from '../../containers';
import CustomizedMap from './CustomizedMap';
import history from '../../core/history';
import s from './EServices.css';
import pans from './panStyle.scss';
import ModalAlert from './ModalAlert';
import _ from 'lodash';
import agentConfig from './agent';
import loadingData from './loading';

import v from './validators';

const {
  leftCol,
  labelCol,
  inputCol,
  inputStyle,
  errorSpanStyle,
  rightCol,
  labelStyle,
  rowStyle,
} = PanelStyle;


const btnStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px',
};

const mpzpOwnerDict = {
  FirstName: {
    label: 'Imię',
    editable: true,
  },
  LastName: {
    label: 'Nazwisko:',
    editable: true,
  },
  CompanyName: {
    label: 'Firma:',
    editable: true,
  },
  AddressCity: {
    label: 'Miejsowość:',
    editable: true,
  },
  AddressStreet: {
    label: 'Ulica:',
    editable: true,
  },
  AddressNumber: {
    label: 'Numer budynku:',
    editable: true,
  },
  AddressFlat: {
    label: 'Numer lokalu:',
    editable: true,
  },
  AddressZipCode: {
    label: 'Kod pocztowy:',
    editable: true,
  },
};

class SporzadzenieMPZP extends React.Component {
  state = {
    mpzpOwner: {
      FirstName: null,
      LastName: null,
      CompanyName: null,
      AddressCity: null,
      AddressStreet: null,
      AddressNumber: null,
      AddressFlat: null,
      AddressZipCode: null
    },
    info: {
      przeznaczenie: null,
      uzasadnienie: null,
      agentAdd: 'NIE',
      agentName: null,
      agentAddress: null,
      agentPostOffice: null,
      agentPostalCode: null,
      agentPhoneNumber: null,
      agentMotionAddress: null,
    },
    selectedParcels: [],
    selectedRoads: [],
    errors: {},
    errorTitle: '',
    errorText: '',
    showError: false,
    attachments: null,
    eserviceDistrict: null,
    loading: false,
    isMounted: false,
  };

  elseString = '.....................';
  spanStyle = {
    color: 'red',
  };

  validators = {
    FirstName: [v.NotNull],
    LastName: [v.NotNull],
    AddressCity: [v.NotNull],
    AddressStreet: [],
    AddressNumber: [v.NotNull],
    AddressZipCode: [v.NotNull],
    przeznaczenie: [v.NotNull],
  };

  nextStep = '/eservices/eserviceSummary/';

  onHide = () => this.setState({ showError: false });

  componentDidMount() {
    fetch(`${process.env.API_URL}/eservice/${this.props.district}/${this.props.query.serviceType}`)
      .then(r => r.json())
      .then(resp => {
        this.setState({
          eserviceDistrict: resp,
        });
      });

    this.setState({ isMounted: true });
  }

  setParcels = (parcels, callback = null) => this.setState({ selectedParcels: parcels });
  setRoads = (roads, callback = null) => this.setState({ selectedRoads: roads });

  render_info = (group, key) => (
    <span>y
      <b>{this.state[group][key] ? this.state[group][key] : this.elseString}</b>
    </span>
  );

  onChange = (e, group) => {
    const name = e.target.name;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.target.value,
        },
      },
      () => this.validate(group, name),
    );
  };

  onChangeAttachments = (attachments, errorMessage) => {
    const errorText = errorMessage.errorText;
    const errorTitle = errorMessage.errorTitle;
    const showError = errorMessage.showError;
    this.setState({ attachments, errorText, errorTitle, showError });
  }

  onChangeSelect = (e, group) => {
    const name = e.state;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.value,
        },
      },
      () => this.validate(group, name),
    );
  }

  getInputWithError = (description, group, field) => (
    <div style={{ textAlign: 'justify' }}>
      {description}
      <input
        className="form-control"
        name={field}
        style={{
          width: '100%',
          borderColor:
            Object.keys(this.state.errors).indexOf(field) > -1 &&
            this.state.errors[field] !== null &&
            this.state.errors[field].length > 0
              ? 'red'
              : '#ccc',
        }}
        value={this.state[group][field] ? this.state[group][field] : ''}
        onChange={e => this.onChange(e, group)}
      />
      {/* RENDER ERROS IN SPAN */}
      {Object.keys(this.state.errors).indexOf(field) > -1 &&
      this.state.errors[field] !== null &&
      this.state.errors[field].length > 0
        ? this.state.errors[field].map((val, index) => (
          <span key={index} style={errorSpanStyle}>
            {val}
          </span>
          ))
        : null}
    </div>
  )

  getTextAreaWithError = (description, group, field) => (
    <p style={{ textAlign: 'justify' }}>
      {description}
      <textarea
        name={field}
        style={{
          width: '100%',
          borderColor:
            Object.keys(this.state.errors).indexOf(field) > -1 &&
            this.state.errors[field] !== null &&
            this.state.errors[field].length > 0
              ? 'red'
              : '#ccc',
        }}
        className="form-control"
        rows={10}
        value={this.state[group][field] ? this.state[group][field] : ''}
        onChange={e => this.onChange(e, group)}
      />
      {/* RENDER ERROS IN SPAN */}
      {Object.keys(this.state.errors).indexOf(field) > -1 &&
      this.state.errors[field] !== null &&
      this.state.errors[field].length > 0
        ? this.state.errors[field].map((val, index) => (
          <span key={index} style={errorSpanStyle}>
            {val}
          </span>
          ))
        : null}
    </p>
  )

  validateField = (group, field) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[group][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateGroup = group => {
    const fields = Object.keys(this.state[group]);
    const errors = {};
    for (const f of fields) {
      const checks = this.validateField(group, f);
      errors[f] = checks;
    }
    return errors;
  };

  validate = (group, field = null, callback = null) => {
    let newState = null;
    if (field) {
      if (Object.keys(this.validators).indexOf(field) > -1) {
        const checks = this.validateField(group, field);
        newState = {
          errors: {
            ...this.state.errors,
            [field]: checks,
          },
        };
      }
    } else if (group) {
      const errors = this.validateGroup(group);
      newState = { errors };
    } else {
      let errors = {};
      const grupy = ["mpzpOwner", "info"];
      for (const g of grupy) {
        const err = this.validateGroup(g);
        errors = { ...errors, ...err };
      }
      newState = { errors: { ...errors } };
    }
    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  };

  haseErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    return false;
  };

  insertTestData = () => {
    this.setState({
        mpzpOwner: {
          FirstName: "Patryk",
          LastName: "Testowy",
          CompanyName: null,
          AddressCity: "Warszawa",
          AddressStreet: "KEN",
          AddressNumber: "85",
          AddressFlat: "87",
          AddressZipCode: "02-797"
        },
        info: {
          przeznaczenie: "hehe",
          uzasadnienie: "takie tam",
        }
    });
  };

  validateAttachmentsContent = () => {
    if (this.state.attachments) {
      for (const attachment of this.state.attachments) {
        if (attachment.name.length < 1) return true;
      }
    }
    return false;
  }

  postValidation = () => {
    const hasFieldErrors = this.haseErrors();
    if (this.state.selectedParcels.length === 0) {
      this.setState({
        errorText: 'Nie wybrano działki ewidencyjnej. Prosimy o wskazanie działki',
        errorTitle: 'Błędnie wypełniony formularz',
        showError: true,
        loading: false,
      }, () => scrollToSection('CustomizedMapScroll'));
      return;
    }

    if (hasFieldErrors) {
      this.setState({
        errorText: 'Uzupełnij pola obowiązkowe.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
        loading: false,
      });
      return;
    }

    if (!this.state.attachments || this.state.attachments.length === 0) {
      this.setState({
        errorText: 'Wymagane jest dodanie załączników do składanego wniosku',
        errorTitle: 'Brak załączników.',
        showError: true,
        loading: false,
      });
      return;
    }

    const hasEmptyAttachment = this.validateAttachmentsContent();
    if (hasEmptyAttachment) {
      this.setState({
        errorText: 'Przynajmniej jeden załącznik jest pusty. Dodaj plik do załączników',
        errorTitle: 'Pusty załącznik.',
        showError: true,
        loading: false,
      });
      return;
    }

    if (!hasFieldErrors && this.state.selectedParcels.length > 0) {
      this.props
        .runService(this.props.serviceInfo.eservice.shortName, this.props.district, {
          mpzpOwner: { ...this.state.mpzpOwner },
          info: { ...this.state.info },
          dzialki: this.state.selectedParcels,
          selectedParcels: this.state.selectedParcels,
          user: {
            ...this.props.serviceInfo.user,
          },
          shortName: this.props.serviceInfo.eservice.shortName,
          urzad: this.props.districts[this.props.prefix],
          attachments: this.state.attachments,
        })
        .then(resp => {
          this.setState({
            loading: false }, () =>
            this.redirectToSummary(resp.jobId));
        });
    }
  };

  redirectToSummary = (jobId) => {
    window.location.href = `${this.nextStep}${jobId}`;
  };

  startService = () => {
    this.validate(null, null, this.postValidation);
  };

  render() {
    const isMobile = this.state.isMounted && isMobileView(window);
    const isTablet = this.state.isMounted && isTabletView(window);
    return (
      <div style={{ paddingTop: '20px' }}>
        <h3 style={{ textAlign: 'center' }}>
          {this.props.serviceInfo.eservice.title}
        </h3>
        <PersonalDataContainer userData={this.props.serviceInfo.user} />

        <GrayPanel
          title={'1. Teren'}
        >
          { renderHelpDesc(isMobile, isTablet) }
          <div id='CustomizedMapScroll'></div>
          <CustomizedMap
            serviceType={this.props.serviceInfo.eservice.shortName}
            setParcels={this.setParcels}
            setSelectDzialki={this.setSelectDzialki}
            selectedParcels={this.state.selectedParcels}
            obreby={this.props.serviceInfo.precints}
            district={this.props.districts[this.props.prefix]}
            prefix={this.props.prefix}
            mapState={this.props.mapstates[0]}
            settings={this.props.serviceInfo.eservice.mapConfig}
            dokumentType={this.props.serviceInfo.eservice}
          />
        </GrayPanel>
        {this.state.eserviceDistrict && this.state.eserviceDistrict.enableAgent ?
          <DecisionContainer
            title={'Pełnomocnik'}
            data={this.state.info}
            errors={this.state.errors}
            formDict={agentConfig.agentInfoDict}
            onChange={e => this.onChange(e, 'info')}
            onChangeSelect={e => this.onChangeSelect(e, 'info')}
          >
            <br />
            <p style={{ fontWeight: 'bold' }}>
            W przypadku złożenia pełnomocnictwa należy uiścić opłatę skarbową w wysokości 17 zł.
            </p>
          </DecisionContainer> : null }
        {this.state.info.agentAdd === 'TAK' ?
          <DecisionContainer
            title={'Dane identyfikacyjne pełnomocnika'}
            data={this.state.info}
            errors={this.state.errors}
            formDict={agentConfig.agentDict}
            onChange={e => this.onChange(e, 'info')}
          /> : null }

        <DecisionContainer
          title={'2. Właściciel'}
          data={this.state.mpzpOwner}
          errors={this.state.errors}
          formDict={mpzpOwnerDict}
          onChange={e => this.onChange(e, 'mpzpOwner')}
        />

        <GrayPanel
          title={'3. Informacje'}
        >
          {this.getTextAreaWithError('Wnioskowane przeznaczenie', 'info', 'przeznaczenie')}
          {this.props.prefix !== 'hrubieszow' ? this.getTextAreaWithError('Uzasadnienie wniosku', 'info', 'uzasadnienie') : null}
        </GrayPanel>

        <GrayPanel
          title={'4. Informacje dla wnioskodawcy'}
        >
          <p><b>Do wniosku należy dołączyć załącznik:</b></p>
          <p>1. Kopia mapy, na której oznaczono teren objęty wnioskiem</p>
          <p><b>Informacja o opłacie:</b><br />
          Wniosek nie podlega opłacie skarbowej.</p>
        </GrayPanel>

        <RodoContent prefix={this.props.prefix} />

        <AttachmentsPanel onChangeAttachments={this.onChangeAttachments} showExtraText={this.props.districts[this.props.prefix].attachmentsToEpuapEnabled}/>

        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />
        <ModalAlert
          title={loadingData.loadingTitle}
          bodyText={loadingData.loadingBody}
          show={this.state.loading}
          name="loadingModal"
          onHide={this.onHide}
          disableButton
        />

        {/* BUTTONS */}
        <div className="row mobile-row">
          <div className="col-sm-12">
            <PowrotDoListyEuslug position="left" prefix={this.props.prefix} />
            <EmptyFileDownloader position="left" prefix={this.props.prefix} serviceType={this.props.serviceInfo.eservice.shortName} />
            <button
              type="submit-lg"
              className={this.props.isDisabled ? 'btn btn-primary disabled' : 'btn btn-primary'}
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={() => this.setState({ loading: true }, () => this.startService())}
            >
              Uruchom
            </button>
            {_.includes(this.props.serviceInfo.user.roles, 'superadmin') ? (
              <button
                type="submit-lg"
                className="btn btn-success"
                style={{ float: 'right', marginRight: '15px', ...btnStyle }}
                onClick={this.insertTestData}
              >
                Insert Test Data
              </button>
            ) : null}
            <button
              type="submit-lg"
              className="btn btn-default"
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={history.goBack}
            >
              Anuluj
            </button>
          </div>
        </div>
      </div>
    );
  }
}

SporzadzenieMPZP.propTypes = {
  serviceInfo: PropTypes.object,
  district: PropTypes.string,
};

const mapState = state => ({
  current_service: state.eservices.current,
  districts: state.district.districts
});

const mapDispatch = {
  runService,
};

export default withStyles(pans)(
  connect(
    mapState,
    mapDispatch,
  )(SporzadzenieMPZP),
);



// WEBPACK FOOTER //
// src/routes/eservices/SporzadzenieMPZP.js